import { SET_MEGAMENU_ACTIVE_ITEM } from 'redux/modules/mega-menu/actions/types';

export default activeItem => ({
  activeItem,
  type: SET_MEGAMENU_ACTIVE_ITEM,
});
